import http from '../../../api/httpClient';

export interface CtoReportsRequest extends Record<string, unknown> {
  sort_by?: 'lhc_branch' | 'total_lhcs' | 'allowed_count' | 'null_count' | 'allowed_pct';
  sort_order?: 'asc' | 'desc';
  page?: number;
  page_size?: number;
  search?: string;
}

export interface CtoLhcSummary {
  lhc_branch: string;
  total_lhcs: number;
  allowed_count: number;
  null_count: number;
  allowed_pct: number;
}

export interface CtoLhcTotals {
  total_lhcs: number;
  total_allowed_count: number;
  total_null_count: number;
  total_allowed_pct: number;
}

export interface CtoReportsPage {
  items: CtoLhcSummary[];
  page: number;
  page_size: number;
  total_items: number;
  total_pages: number;
  has_previous: boolean;
  has_next: boolean;
  total: CtoLhcTotals;
}

export async function fetchReportsData(
  payload: CtoReportsRequest
): Promise<CtoReportsPage> {
  return http.post("/api/v1/cto/reports/sim-consent/fetch-data", payload);
}



// --- CN Analysis Summary Types ---
export interface CnAnalysisSummaryRequest {
  dateFrom?: string | null;
  dateTo?: string | null;
}

export interface CnSummaryMetrics {
  label: string;
  count: number;
  cn_value: number;
  actual_weight: number;
  charge_weight: number;
}

export interface CnAnalysisSummaryResponse {
  total: CnSummaryMetrics;
  bank_cns: CnSummaryMetrics;
  no_ewaybill: CnSummaryMetrics;
}

export async function fetchCnAnalysisSummary(
  payload?: CnAnalysisSummaryRequest
): Promise<CnAnalysisSummaryResponse> {

  const query = new URLSearchParams();
  if (payload?.dateFrom) query.append("dateFrom", payload.dateFrom);
  if (payload?.dateTo) query.append("dateTo", payload.dateTo);

  const queryString = query.toString() ? `?${query.toString()}` : "";

  return http.get(`/api/v1/cto/reports/cn-analysis/summary${queryString}`);
}




export type CnFilterType = "total" | "bank" | "no_ewaybill";

export interface CnAnalysisDataRequest extends Record<string, unknown>  {
  filter?: CnFilterType;
  page?: number;
  page_size?: number;
  sort_by?: string | null;
  sort_order?: "asc" | "desc" | null;
  dateFrom?: string | null;
  dateTo?: string | null;
}

export interface CnRow {
  booking_branch: string;
  branch_name: string;
  branch_value: number;
  actual_weight: number;
  charge_weight: number;
  cn_count: number;
}

export interface CnAnalysisPage {
  rows: CnRow[];
  page: number;
  page_size: number;
  total_items: number;
  total_pages: number;
  has_previous: boolean;
  has_next: boolean;
}

export async function fetchCnAnalysisData(
  payload: CnAnalysisDataRequest
): Promise<CnAnalysisPage> {
  return http.post("/api/v1/cto/reports/cn-analysis/fetch-data", payload);
}


export interface FetchBranchCnsRequest extends Record<string, unknown> {
  booking_branch: string;
  filter?: CnFilterType;
  page?: number;
  page_size?: number;
  sort_by?: string | null;
  sort_order?: "asc" | "desc" | null;
  dateFrom?: string | null;
  dateTo?: string | null;
}

export interface BranchCnRow {
  cn_number: string;
  cn_date: string;
  cn_value: number;
  actual_weight: number;
  charge_weight: number;
  cn_origin: string;
  cn_destination: string;
  consignor: string;
  consignee: string;
}

export interface BranchCnResponse {
  rows: BranchCnRow[];
  page: number;
  page_size: number;
  total_items: number;
  total_pages: number;
  has_previous: boolean;
  has_next: boolean;
}

export async function fetchBranchCns(payload: FetchBranchCnsRequest): Promise<BranchCnResponse> {
  return http.post("/api/v1/cto/reports/cn-analysis/fetch-branch-cns", payload);
}
